import { createGrid, themeQuartz } from 'ag-grid-community'
import { makeColumnDefs } from './make-column-defs.js'
import { makeRows } from './make-rows.js'

let gridApi

export const viewParams = {}

export function updateView () {
  const rows = makeRows(viewParams.groupContactsResponse)
  // console.log('rows', rows)

  const columnDefs = makeColumnDefs(viewParams)
  // console.log(columnDefs)

  const containerId = 'viewGrid'
  const gridContainerElement = document.getElementById(containerId)
  console.log('gridContainerElement', gridContainerElement)

  if (gridApi && gridContainerElement?.innerHTML) {
    gridApi.updateGridOptions({
      rowData: rows,
      columnDefs
    })
  } else {
    const gridOptions = {
      // pinnedTopRowData: [{ row: 'linkToXero' }],
      rowData: rows,
      columnDefs,
      defaultColDef: {
        filter: true,
        floatingFilter: true,
        wrapHeaderText: true,
        autoHeaderHeight: true
      },
      context: {
        ...viewParams
      },
      theme: themeQuartz,
      overlayNoRowsTemplate: 'No contacts matching',
      // autoSizeStrategy: {
      //   type: 'fitCellContents'
      // },
      onCellClicked: function (cellParams) {
        console.log('onCellClicked', cellParams)
      }
    }

    gridApi = createGrid(gridContainerElement, gridOptions)
    console.log('grid created', gridApi)
  }
}
